const data = [
  {
    id: 1,
    name: "رضا اسدی",
    job: "طراح وب",
    image:
      "https://images.pexels.com/photos/9154716/pexels-photo-9154716.jpeg?cs=srgb&dl=pexels-cottonbro-9154716.jpg&fm=jpg",
    text: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است",
  },
  {
    id: 2,
    name: "حسام نشاد",

    job: "برنامه نویس",
    image:
      "https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    text: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است",
  },
  {
    id: 3,
    name: " ندا امیرفیروز ",
    job: "گرافیست",
    image:
      "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    text: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است",
  },
];

export default data;
